export const ANALYTICS_FILTER_DROPDOWN = 'filterRoleDropdown';
export const ANALYTICS_FILTER_DROPDOWN_ITEM = 'roleOption';
